import React from 'react';
import PixelGradeBadge from './PixelGradeBadge';
import GradeProgressBar from './GradeProgressBar';
import { scoreToGrade } from '../utils/GradeUtils';

interface TrustScoreCardProps {
  title: string;
  subtitle?: string;
  score: number;
  agentCount?: number;
  onlineCount?: number;
  compact?: boolean;
}

const TrustScoreCard: React.FC<TrustScoreCardProps> = ({
  title,
  subtitle,
  score,
  agentCount,
  onlineCount,
  compact = false,
}) => {
  const { label, color } = scoreToGrade(score);

  if (compact) {
    return (
      <div className="flex items-center gap-3 py-2">
        <PixelGradeBadge score={score} size={32} />
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between mb-0.5">
            <span className="text-sm text-white/80 truncate">{title}</span>
            {agentCount !== undefined && (
              <span className="text-[10px] text-white/30 ml-2">{onlineCount}/{agentCount} online</span>
            )}
          </div>
          <GradeProgressBar score={score} compact />
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white/[0.02] border border-white/[0.06] rounded-xl p-5">
      <div className="flex items-start gap-4">
        <PixelGradeBadge score={score} size={48} />
        <div className="flex-1">
          <div className="flex items-center justify-between">
            <div>
              <h3 className="text-base text-white/90 font-medium">{title}</h3>
              {subtitle && <p className="text-xs text-white/40 mt-0.5">{subtitle}</p>}
            </div>
            <div className="text-right">
              <span className="text-[10px] uppercase tracking-wider px-2 py-0.5 rounded-full" style={{ color, background: `${color}15`, border: `1px solid ${color}30` }}>
                {label}
              </span>
            </div>
          </div>

          <div className="mt-3">
            <GradeProgressBar score={score} />
          </div>

          {agentCount !== undefined && (
            <div className="flex items-center gap-4 mt-3 pt-3 border-t border-white/[0.04]">
              <span className="text-xs text-white/40">
                <span className="text-white/70 font-medium">{agentCount}</span> agents
              </span>
              {onlineCount !== undefined && (
                <span className="text-xs text-white/40">
                  <span className="text-anchor-teal font-medium">{onlineCount}</span> online
                </span>
              )}
              <span className="text-xs text-white/40 ml-auto">
                Fleet health: <span className="font-medium" style={{ color }}>{score}%</span>
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrustScoreCard;
